import { createContext, useContext, useState } from 'react';
import useAuth from '../hooks/useAuth';
import { useLocation } from 'react-router-dom';

export const AppContext = createContext(null);

export const AppContextProvider = ({ children }) => {
  const [savedCheckLoanPageData, setSavedCheckLoanPageData] = useState(null);
  const auth = useAuth();
  const location = useLocation();

  return (
    <AppContext.Provider
      key={location.pathname}
      value={{
        auth,
        savedCheckLoanPageData,
        setSavedCheckLoanPageData,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => useContext(AppContext);
